"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentListElement = exports.CommentList = exports.CommentSection = void 0;
var React = require("react");
var moment = require("moment");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var generic_1 = require("../generic");
var CommentSection = (function (_super) {
    __extends(CommentSection, _super);
    function CommentSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommentSection.prototype.render = function () {
        var props = this.props;
        return (React.createElement("div", null,
            React.createElement(generic_1.Header, { text: gettext("Comments") }),
            React.createElement(generic_1.ExpandingTextArea, { placeholder: gettext("Type comment here"), submitButtonText: gettext("Post Comment"), onSubmit: props.onSubmit.bind(self), onChange: props.onChange.bind(self), value: "" }),
            React.createElement(CommentList, { comments: props.comments })));
    };
    CommentSection = __decorate([
        mobx_react_1.observer
    ], CommentSection);
    return CommentSection;
}(React.Component));
exports.CommentSection = CommentSection;
var CommentList = (function (_super) {
    __extends(CommentList, _super);
    function CommentList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommentList.prototype.render = function () {
        var props = this.props;
        return (React.createElement("div", { className: "CommentList" }, props.comments.length > 0
            ?
                props.comments.map(function (comment) {
                    return React.createElement(CommentListElement, { key: comment.id, comment: comment });
                })
            :
                React.createElement("p", { className: "CommentList__NoComments" }, gettext("No comments added") + ".")));
    };
    CommentList = __decorate([
        mobx_react_1.observer
    ], CommentList);
    return CommentList;
}(React.Component));
exports.CommentList = CommentList;
var CommentListElement = (function (_super) {
    __extends(CommentListElement, _super);
    function CommentListElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommentListElement.prototype.putComment = function (comment) {
        var values = {
            comment: comment
        };
        App_1.store.controlDialog.saveComment(this.props.comment, values);
    };
    CommentListElement.prototype.deleteComment = function () {
        App_1.store.controlDialog.deleteComment(this.props.comment);
    };
    CommentListElement.prototype.render = function () {
        var props = this.props;
        var isOwner = props.comment.owner === App_1.store.controlDialog.userProxyId;
        return (React.createElement("div", { className: "CommentListElement" },
            React.createElement("div", { className: "d-flex" },
                React.createElement("div", { className: "font-weight-bold" }, props.comment.owner_full_name),
                React.createElement("div", { className: "flex-grow-1" }),
                React.createElement("div", null, moment(props.comment.date).format("L LT")),
                (isOwner || App_1.store.controlDialog.hasDeleteCommentPerm) &&
                    React.createElement("span", { className: "pl-3", onClick: this.deleteComment.bind(this) },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.trash }))),
            React.createElement("div", { className: "CommentListElement__Comment" }, isOwner ?
                React.createElement("div", null,
                    React.createElement(generic_1.EditableText, { value: props.comment.comment, onSubmit: this.putComment.bind(this) }))
                :
                    React.createElement("div", null, props.comment.comment)),
            React.createElement(generic_1.Clearfix, null)));
    };
    CommentListElement = __decorate([
        mobx_react_1.observer
    ], CommentListElement);
    return CommentListElement;
}(React.Component));
exports.CommentListElement = CommentListElement;
